/**
 * Persistencia ligera de atribución (referido, landing, UTMs) para registro y analítica.
 * Usa sessionStorage: se limpia al cerrar la pestaña (comportamiento alineado con la guía de landing).
 */

const REFERRAL_KEY = "gold_referral_code";
const LANDING_SLUG_KEY = "gold_landing_slug";

const UTM_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

export function saveReferralCode(code) {
  if (code == null || String(code).trim() === "") return;
  sessionStorage.setItem(REFERRAL_KEY, String(code).trim());
}

export function getReferralCode() {
  return sessionStorage.getItem(REFERRAL_KEY) || "";
}

export function clearReferralCode() {
  sessionStorage.removeItem(REFERRAL_KEY);
}

export function saveLandingSlug(slug) {
  if (slug == null || String(slug).trim() === "") return;
  sessionStorage.setItem(LANDING_SLUG_KEY, String(slug).trim());
}

export function getLandingSlug() {
  return sessionStorage.getItem(LANDING_SLUG_KEY) || "";
}

export function clearLandingSlug() {
  sessionStorage.removeItem(LANDING_SLUG_KEY);
}

/**
 * @param {URLSearchParams} searchParams
 */
export function saveUtmFromSearch(searchParams) {
  if (!searchParams || typeof searchParams.forEach !== "function") return;
  UTM_PARAM_KEYS.forEach((key) => {
    const value = searchParams.get(key);
    if (value) sessionStorage.setItem(`gold_${key}`, value);
  });
}

export function getUtmParams() {
  const out = {};
  UTM_PARAM_KEYS.forEach((key) => {
    const v = sessionStorage.getItem(`gold_${key}`);
    if (v) out[key] = v;
  });
  return out;
}
